import React, { useEffect, useRef } from 'react';
import { CHECKBOX, CHECKBOX_LABEL } from './uiTokens';
import type { CheckboxProps } from './types/UIProps';

export type { CheckboxProps };

export function Checkbox({
  checked,
  indeterminate = false,
  disabled = false,
  label = '',
  ariaLabel,
  className = '',
  onChange,
}: CheckboxProps): React.ReactElement {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    el.indeterminate = indeterminate && !checked;
  }, [indeterminate, checked]);

  return (
    <label className={`${CHECKBOX_LABEL} ${className}`.trim()}>
      <input
        ref={inputRef}
        type="checkbox"
        className={CHECKBOX}
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.checked)}
      />
      {label}
    </label>
  );
}
